import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles/legacy-base.css";
// CSS aislado de los componentes en el lugar del bundle de Blazor (entre app.css y portal.css) y en su orden (portal,
// después Bheli.Web.Feedback): el CSS global que viene después (team.css y otros) los pisa igual que en el portal actual.
import "./styles/scopedOrder";
import "./styles/legacy.css";
import { App } from "./App";
import { installClientErrors } from "./errors/clientErrors";

installClientErrors();

// Antes que React Router: el chat atiende atrás/adelante en su propia URL sin que el portal vuelva a navegar (como el
// gancho de App.razor del portal actual).
window.addEventListener(
  "popstate",
  (event) => {
    const handler = (window as unknown as { __bheliChatPopState?: ((event: PopStateEvent) => boolean) | null })
      .__bheliChatPopState;
    if (handler && handler(event)) event.stopImmediatePropagation();
  },
  true,
);

const root = document.getElementById("root");
if (!root) throw new Error("No existe #root.");
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
